<template>
	<!-- 评论输入表单 -->
	<div class="form">
		<h3>
			发表评论
			<el-button class="m-small" size="mini" type="primary" @click="$store.commit(SET_PARENT_COMMENT_ID, -1)"
				v-show="parentCommentId!==-1">取消回复</el-button>
		</h3>
		<el-form :inline="true" :model="commentForm" :rules="formRules" ref="formRef" size="small">
			<el-input :class="'textarea'" type="textarea" :rows="5" v-model="commentForm.content"
				placeholder="评论千万条，友善第一条" maxlength="250" show-word-limit :validate-event="false"></el-input>
			<div class="el-form-item el-form-item--small emoji">
				<img src="https://cdn.naccl.top/blog/img/paopao/1.png" @click="showEmojiBox">
				<div class="mask" v-show="emojiShow" @click="hideEmojiBox"></div>
				<div class="emoji-box" v-show="emojiShow">
					<div class="emoji-title">
						<span>{{ activeEmojiTab === 0 ? 'tv_小电视' : activeEmojiTab === 1 ? '阿鲁' : '泡泡' }}</span>
					</div>
					<div class="emoji-wrap" v-show="activeEmojiTab===0">
						<div class="emoji-list" v-for="(img,index) in tvMapper" :key="index"
							@click="insertEmoji(img.name)">
							<img :src="img.src" :title="img.name">
						</div>
					</div>
					<div class="emoji-wrap" v-show="activeEmojiTab===1">
						<div class="emoji-list" v-for="(img,index) in aruMapper" :key="index"
							@click="insertEmoji(img.name)">
							<img :src="img.src" :title="img.name">
						</div>
					</div>
					<div class="emoji-wrap" v-show="activeEmojiTab===2">
						<div class="emoji-list" v-for="(img,index) in paopaoMapper" :key="index"
							@click="insertEmoji(img.name)">
							<img :src="img.src" :title="img.name">
						</div>
					</div>
					<div class="emoji-tabs">
						<a class="tab-link" :class="{'on':activeEmojiTab===0}" @click="activeEmojiTab=0">
							<img src="https://cdn.naccl.top/blog/img/tv/1.png">
						</a>
						<a class="tab-link" :class="{'on':activeEmojiTab===1}" @click="activeEmojiTab=1">
							<img src="https://cdn.naccl.top/blog/img/aru/1.png">
						</a>
						<a class="tab-link" :class="{'on':activeEmojiTab===2}" @click="activeEmojiTab=2">
							<img src="https://cdn.naccl.top/blog/img/paopao/1.png">
						</a>
					</div>
				</div>
			</div>

			<el-form-item prop="nickname">
				<el-input v-model="commentForm.nickname" placeholder="昵称（先填邮箱会以qq号为昵称）" :validate-event="false"
					v-popover:nicknamePopover>
					<i slot="prefix" class="el-input__icon el-icon-user"></i>
				</el-input>
			</el-form-item>
			<el-form-item prop="email">
				<el-popover ref="emailPopover" placement="bottom" trigger="focus" :content="emailTipContent"
					v-model="emailTipVisible"></el-popover>
				<el-input v-model="commentForm.email" placeholder="QQ 邮箱或普通邮箱" :validate-event="false"
					v-popover:emailPopover @input="handleEmailInput" @blur="handleEmailBlur">
					<i slot="prefix" class="el-input__icon el-icon-message"></i>
					<i slot="suffix" class="el-icon-loading" v-show="loadingAvatar"></i>
				</el-input>
			</el-form-item>
			<el-form-item prop="website">
				<el-popover ref="websitePopover" placement="bottom" trigger="focus" content="可以让我参观一下吗😊"></el-popover>
				<el-input v-model="commentForm.website" placeholder="https://（可选）" :validate-event="false"
					v-popover:websitePopover>
					<i slot="prefix" class="el-input__icon el-icon-map-location"></i>
				</el-input>
			</el-form-item>
			<el-form-item label="订阅回复">
				<el-switch v-model="commentForm.notice"></el-switch>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="medium" v-throttle="[postForm,`click`,3000]">发表评论</el-button>
			</el-form-item>
		</el-form>
		<!-- 头像预览 -->
		<div class="avatar-preview" v-if="false">
			<img :src="tempAvatar" alt="头像预览" title="已获取 QQ 头像">
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import {
		checkEmail,
		checkUrl
	} from "@/common/reg";
	import {
		SET_PARENT_COMMENT_ID,
		SET_COMMENT_FORM_AVATAR
	} from "@/store/mutations-types";
	import tvMapper from '@/plugins/tvMapper.json'
	import aruMapper from '@/plugins/aruMapper.json'
	import paopaoMapper from '@/plugins/paopaoMapper.json'
	import {
		getQQInfoByEmail
	} from '@/api/comment'

	const validateWebsite = (rule, value, callback) => {
		if (value) {
			return checkUrl(rule, value, callback)
		}
		callback()
	}
	export default {
		name: "CommentForm",
		computed: {
			...mapState(['parentCommentId', 'commentForm', 'commentQuery'])
		},
		data() {
			return {
				SET_PARENT_COMMENT_ID,
				formRules: {
					nickname: [{
							required: true,
							message: '请输入评论昵称'
						},
						{
							max: 18,
							message: '昵称不可多于 15 个字符'
						}
					],
					email: [{
							required: true,
							message: '请输入评论邮箱'
						},
						{
							validator: checkEmail
						}
					],
					website: [{
							required: false
						},
						{
							validator: validateWebsite
						}
					]
				},
				emojiShow: false,
				activeEmojiTab: 0,
				tvMapper: [],
				aruMapper: [],
				paopaoMapper: [],
				textarea: null,
				start: 0,
				end: 0,
				// 新增数据
				tempAvatar: '', // 临时头像预览
				loadingAvatar: false, // 是否正在加载头像
				emailTipContent: '用于接收回复邮件', // 邮箱提示内容
				emailTipVisible: false, // 邮箱提示框显示状态
				fetchTimer: null // 防抖定时器
			}
		},
		created() {
			this.tvMapper = tvMapper
			this.aruMapper = aruMapper
			this.paopaoMapper = paopaoMapper
		},
		mounted() {
			this.textarea = document.querySelector('.el-form textarea')
		},
		methods: {
			showEmojiBox() {
				this.start = this.textarea.selectionStart
				this.end = this.textarea.selectionEnd
				this.textarea.focus()
				this.textarea.setSelectionRange(this.start, this.end)
				this.emojiShow = !this.emojiShow
			},
			insertEmoji(name) {
				let str = this.commentForm.content
				this.commentForm.content = str.substring(0, this.start) + name + str.substring(this.end)
				this.start += name.length
				this.end = this.start
				this.textarea.focus()
				this.$nextTick(() => {
					this.textarea.setSelectionRange(this.start, this.end)
				})
			},
			hideEmojiBox() {
				this.emojiShow = false
				this.textarea.focus()
				this.textarea.setSelectionRange(this.start, this.end)
			},

			/**
			 * 处理邮箱输入（防抖）
			 */
			handleEmailInput() {
				// 清除之前的定时器
				if (this.fetchTimer) {
					clearTimeout(this.fetchTimer)
				}

				// 隐藏头像预览
				this.tempAvatar = ''

				const email = this.commentForm.email.trim()

				// 如果是 QQ 邮箱，延迟 500ms 后请求头像
				if (email && email.endsWith('@qq.com')) {
					this.emailTipContent = '正在识别 QQ 邮箱...'
					this.fetchTimer = setTimeout(() => {
						this.fetchQQAvatar(email)
					}, 1000)
				} else {
					this.emailTipContent = '用于接收回复邮件'
				}
			},

			/**
			 * 处理邮箱失去焦点
			 */
			handleEmailBlur() {
				const email = this.commentForm.email.trim()

				// 如果邮箱是 QQ 邮箱且还没有获取头像，则立即请求
				if (email && email.endsWith('@qq.com') && !this.tempAvatar) {
					if (this.fetchTimer) {
						clearTimeout(this.fetchTimer)
						this.fetchTimer = null
					}
					this.fetchQQAvatar(email)
				}
			},

			/*
			 * 获取 QQ 头像 - 调用 getQQInfoByEmail 接口
			 */
			async fetchQQAvatar(email) {
				this.loadingAvatar = true
				this.emailTipContent = '正在获取 QQ 头像...'
				this.emailTipVisible = true

				// ⭐ 新增：先检查本地缓存
				const cachedKey = 'avatar_cache_' + email.toLowerCase()
				const cachedData = localStorage.getItem(cachedKey)

				if (cachedData) {
					try {
						const {
							avatar,
							nickname,
							timestamp
						} = JSON.parse(cachedData)
						// 检查缓存是否过期（7 天有效期）
						const isExpired = Date.now() - timestamp > 7 * 24 * 60 * 60 * 1000

						if (!isExpired && avatar) {
							// 使用缓存数据，不再请求后端
							this.tempAvatar = avatar
							
							// ⭐ 更新 Vuex 状态和 commentForm 用于第二次回复用的
							this.$store.commit(SET_COMMENT_FORM_AVATAR, avatar)
							
							if (!this.commentForm.nickname || this.commentForm.nickname.trim() === '') {
								this.commentForm.nickname = nickname
							}
							this.emailTipContent = '✓ 已获取 QQ 头像（缓存）'
							this.$notify({
								title: '成功',
								message: '使用缓存的 QQ 头像',
								type: 'success',
								duration: 1500
							})
							this.loadingAvatar = false
							return
						} else {
							// 清除过期缓存
							localStorage.removeItem(cachedKey)
						}
					} catch (e) {
						localStorage.removeItem(cachedKey)
					}
				}

				// ⭐ 缓存未命中，请求后端接口
				try {
					const response = await getQQInfoByEmail(email)

					if (response.code === 200) {
						this.tempAvatar = response.data.avatar

						// ⭐ 修复：使用正确的变量名
						this.$store.commit(SET_COMMENT_FORM_AVATAR, response.data.avatar)
						// 如果昵称为空，自动填充为 QQ 号
						if (!this.commentForm.nickname || this.commentForm.nickname.trim() === '') {
							this.commentForm.nickname = response.data.nickname
						}

						this.emailTipContent = '✓ 已获取 QQ 头像'

						// ⭐ 新增：保存到本地缓存
						localStorage.setItem(cachedKey, JSON.stringify({
							avatar: response.data.avatar,
							nickname: response.data.nickname,
							timestamp: Date.now()
						}))

						this.$notify({
							title: '成功',
							message: 'QQ 头像获取成功',
							type: 'success',
							duration: 2000
						})
					} else {
						this.handleFetchError(response.msg || '获取失败')
					}
				} catch (error) {
					console.error('获取 QQ 头像失败:', error)
					// ⭐ 增强错误信息处理
					let errorMessage = '网络请求失败'
					
					// 如果是 HTTP 错误，尝试提取更详细的信息
					if (error.response) {
						// 后端返回了错误响应
						errorMessage = error.response.data?.msg || error.response.data?.message || `HTTP ${error.response.status}`
					} else if (error.message) {
						errorMessage = error.message
					}
					
					this.handleFetchError(errorMessage)
				} finally {
					this.loadingAvatar = false
				}
			},

			/**
			 * 处理获取错误
			 */
			handleFetchError(message) {
				this.emailTipContent = '✗ ' + message
				this.tempAvatar = ''
				this.$notify({
					title: '提示',
					message: message,
					type: 'warning',
					duration: 3000
				})

				// 3 秒后恢复默认提示
				setTimeout(() => {
					if (!this.tempAvatar) {
						this.emailTipContent = '用于接收回复邮件'
					}
				}, 3000)
			},

			postForm() {
				const adminToken = window.localStorage.getItem('adminToken')
				if (adminToken) {
					//博主登录后，localStorage 中会存储 token，在后端设置属性，可以不校验昵称、邮箱
					if (this.commentForm.content === '' || this.commentForm.content.length > 250) {
						return this.$notify({
							title: '评论失败',
							message: '评论内容有误',
							type: 'warning'
						})
					} else {
						return this.$store.dispatch('submitCommentForm', adminToken)
					}
				}
				const blogToken = window.localStorage.getItem(`blog${this.commentQuery.blogId}`)
				this.$refs.formRef.validate(valid => {
					if (!valid || this.commentForm.content === '' || this.commentForm.content.length > 250) {
						this.$notify({
							title: '评论失败',
							message: '请正确填写评论',
							type: 'warning'
						})
					} else {
						// 如果有临时头像和 QQ 号，添加到提交数据中 这样是有bug的
						if (this.tempAvatar) {
							this.commentForm.avatar = this.tempAvatar
						}
						this.$store.dispatch('submitCommentForm', blogToken ? blogToken : '')
					}
				})
			},

		}
	}
</script>

<style>
	.form {
		background: #fff;
		position: relative;
	}

	.form h3 {
		margin: 5px;
		font-weight: 500 !important;
	}

	.form .m-small {
		margin-left: 5px;
		padding: 4px 5px;
	}

	.el-form .textarea {
		margin-top: 5px;
		margin-bottom: 15px;
	}

	.el-form textarea {
		padding: 6px 8px;
	}

	.el-form textarea,
	.el-form input {
		color: black;
	}

	.el-form .el-form-item__label {
		padding-right: 3px;
	}

	.emoji {
		margin-right: 5px;
		position: relative;
		user-select: none;
	}

	.emoji>img {
		cursor: pointer;
		transition: all 0.3s ease-in-out;
		-webkit-transition: all 0.3s ease-in-out;
		-moz-transition: all 0.3s ease-in-out;
		-o-transition: all 0.3s ease-in-out;
	}

	.emoji>img:hover {
		transform: rotate(360deg);
		-webkit-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-o-transform: rotate(360deg);
	}

	.emoji-box {
		color: #222;
		overflow: visible;
		background: #fff;
		border: 1px solid #E5E9EF;
		box-shadow: 0 11px 12px 0 rgba(106, 115, 133, 0.3);
		border-radius: 8px;
		width: 340px;
		position: absolute;
		top: 40px;
		z-index: 100;
	}

	.emoji-box * {
		box-sizing: content-box;
	}

	.emoji-box .emoji-title {
		font-size: 12px;
		line-height: 16px;
		margin: 13px 15px 0;
		color: #757575;
	}

	.emoji-box .emoji-wrap {
		margin: 6px 11px 0 11px;
		height: 185px;
		overflow: auto;
		word-break: break-word;
	}

	.emoji-box .emoji-wrap .emoji-list {
		height: 33px;
		color: #111;
		border-radius: 4px;
		transition: background 0.2s;
		display: inline-block;
		outline: 0;
		cursor: pointer;
	}

	.emoji-box .emoji-wrap .emoji-list:hover {
		background-color: #ddd;
	}

	.emoji-box .emoji-wrap .emoji-list img {
		margin: 4px;
		width: 25px;
		height: 25px;
	}

	.emoji-box .emoji-tabs {
		position: relative;
		height: 36px;
		overflow: hidden;
		background-color: #f4f4f4;
		border-radius: 0 0 4px 4px;
	}

	.emoji-box .emoji-tabs .tab-link {
		cursor: pointer;
		float: left;
		padding: 7px 18px;
		width: 22px;
		height: 22px;
	}

	.emoji-box .emoji-tabs .tab-link.on {
		background-color: #fff;
	}

	.emoji-box .emoji-tabs .tab-link img {
		width: 22px;
	}

	.emoji-box .emoji-tabs .tab-link:hover {
		background: #e7e7e7;
	}

	.mask {
		pointer-events: auto;
		position: fixed;
		z-index: 99;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}

	/* 头像预览 */
	.avatar-preview {
		display: inline-block;
		animation: fadeIn 0.3s ease-in-out;
		flex-shrink: 0;
	}

	.avatar-preview img {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		object-fit: cover;
		border: 2px solid #409EFF;
		box-shadow: 0 2px 8px 0 rgba(64, 158, 255, 0.3);
		transition: transform 0.2s ease, box-shadow 0.2s ease;
		cursor: pointer;
	}

	.avatar-preview img:hover {
		transform: scale(1.1);
		box-shadow: 0 4px 12px 0 rgba(64, 158, 255, 0.5);
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
</style>